import api from "./axios";
import { apiPaths } from "./paths";
import type { Article, PaginatedResponse } from "@/types";

export const getArticles = (params?: {
  categoryId?: string;
  page?: number;
  limit?: number;
}) =>
  api
    .get<PaginatedResponse<Article>>(apiPaths.articles.list(), { params })
    .then((r) => r.data);

export const getLatestArticles = (limit: number = 20) =>
  api
    .get<Article[]>(apiPaths.articles.latest(), { params: { limit } })
    .then((r) => r.data);

export const getArticle = (id: string) =>
  api.get<Article>(apiPaths.articles.one(id)).then((r) => r.data);

export const deleteArticle = (id: string) =>
  api.delete<void>(apiPaths.articles.one(id));
